import { render, staticRenderFns } from "./LongTextDisplay.vue?vue&type=template&id=918d1a70&scoped=true"
var script = {}
import style0 from "./LongTextDisplay.vue?vue&type=style&index=0&id=918d1a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918d1a70",
  null
  
)

export default component.exports